var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { transformObjectsToTreeObjects } from "../../../../../shared/utils/services/transformObjectsToTreeObjects";
import { sortObjects } from "../../../../../shared/utils/system/sortObjects";
import { ObjectTypesValues } from "../../../../../shared/enums/object-types-values";
var createObjectsSlice = function (set, get, _api) { return ({
    selectedObject: null,
    createdObject: null,
    objects: [],
    addObject: function (object, isNeedToSelect, objects) {
        var newObjects = transformObjectsToTreeObjects(__spreadArray(__spreadArray([], sortObjects(objects !== null && objects !== void 0 ? objects : get().objects).filter(function (item) { return item.id !== object.id; }), true), [
            object,
        ], false));
        set(function () { return ({
            objects: newObjects,
        }); });
        if (!isNeedToSelect)
            return;
        var newSelectedObject = newObjects.find(function (item) { return item.id === object.id; });
        set(function () { return ({
            selectedObject: newSelectedObject,
        }); });
    },
    selectObjects: function (newObjects, needToSetManufacture) {
        set(function () { return ({
            objects: newObjects,
        }); });
        if (!get().selectedObject)
            return;
        if (needToSetManufacture) {
            var newFactory_1 = newObjects.find(function (item) { return item.idObjectType === ObjectTypesValues.Manufacture; });
            set(function () { return ({
                selectedObject: newFactory_1,
            }); });
            return;
        }
        var newSelectedObject = newObjects.find(function (object) { return object.id === get().selectedObject.id; });
        if (!newSelectedObject)
            return;
        set(function () { return ({
            selectedObject: newSelectedObject,
        }); });
    },
    selectObject: function (object) {
        return set(function () { return ({ selectedObject: object }); });
    },
    setCreatedObject: function (object) { return set(function () { return ({ createdObject: object }); }); },
}); };
export default createObjectsSlice;
